import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useCalendarHeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerContainer: {
      display: 'flex',
      backgroundColor: '#f5f5f5',
      borderBottom: '1px solid #e0e0e0',
      padding: theme.spacing(1, 2),
    },
    dayColumn: {
      flex: 1,
      textAlign: 'center',
      padding: theme.spacing(1),
      fontWeight: 600,
      color: '#333',
    },
    weekendDay: {
      color: '#666',
    },
  }),
);
